var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'position-fixed modal d-flex flex-column justify-content-center container-fluid ' +
      (_vm.swag ? _vm.swag : '')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }